// feeds HOME
import Seo from "./Seo";

function MainContentH({resource}) {
    
  
    return (
      <>
      <Seo title="True Liberty North :: Home Page" 
        description="True Liberty North explores deeper insight and understanding into the Bible, life, politics, philosophy, and history." 
        keywords="TrueLibertyNorth, Christian Apologetics" />
      <h2 className="sectionHeader"><span className="by">{resource.by}</span>{resource.firstName} {resource.lastName} <span className="by">{resource.dates}</span></h2>
      <blockquote className="main">
      <p><b><i>{resource.quotes[0].from}</i></b><cite className="citeTitle">{resource.quotes[0].title}</cite></p>
      {resource.quotes[0].content.map((paragraph, i) => {
        if (paragraph.list) { 
          return (
            <>
            <p key={i}>
                <ul>
                    {paragraph.list.map((listItem, li) => {
                        return (<li key={li}><b>{listItem.bold}</b>{listItem.normal}</li>)
                    })}
                </ul>
            </p>
            </>
          )} else {
        return (
          <p key={i}><b>{paragraph.bold}</b>{paragraph.normal}<b>{paragraph.bold2}</b></p>
      )}    
       })}
      
        
      </blockquote>
      </>
  );
  };
  export default MainContentH;